export default __webpack_public_path__ + "static/media/icon-down.6fbe3ec5.svg";